import { uniqBy } from "lodash";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then, When } from "react-if";

// import HBCategorySelect from "../../components/HBCategorySelect";
// import FilterSelect from "@/components/FilterSelect";
import { AD_POSITION } from "@/constants/ads";
import { RENDERCARDTYPE } from "@/constants/renderCardType";
import useAppStore from "@/context/store";
import { setSearch } from "@/tracker/shared/global";
import filterUrlParams from "@/utils/filterUrlParams";
import { stewardInstance } from "@/utils/steward";
import { useMount } from "ahooks";
import PinList from "../../components/PinList";
import {
  getAds,
  getDeliveryDetail,
  getSearchPinsByQingzhou,
} from "../../services";
import RecommendTopicList from "../Search/RecommendTopicList";
import { RelationWords } from "../Search/RelationWords";
import FilterToggleButton from "../Search/SearchFilter/FilterToggleButton";
import RecallSearch from "../SearchPinList/recallSearch";
import styles from "./index.module.less";

// import { SORT_LIST, SORT_ITEM_MAP } from "@/constants/sort";
// import { MATERIAL_FILE_TYPE_LIST, MATERIAL_FILE_TYPE_ITEM_MAP } from "@/constants/materialFileType";
// import { COLOR_LIST, COLOR_ITEM_MAP } from "@/constants/color";

export default function SearchMaterialList({
  query,
  empty,
  searchResult,
  setRecommend,
  recommend,
  recommendResultTest,
  recommendTopicListColNum = 3,
  isFilterPanelVisible,
  searchWord,
  onCloseRecommend,
  recommendSearchWords = [],
}) {
  const pageRef = useRef(searchResult ? 2 : 1);
  const randomNumRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(searchResult || []);
  const [ads, setAds] = useState([]);
  const [questionaire, setQuestionaire] = useState(null);
  const [keywordMap, setKeywordMap] = useState({});
  const [isRecallSearch, setIsRecalSearch] = useState(false);
  const [isAllMatch, setIsAllMatch] = useState(true);
  const [splitWords, setSplitWords] = useState([]);
  const [busy, setBusy] = useState(false);
  const router = useRouter();

  const { q, sort, type, filterIds } = query;
  const initRef = useRef(!searchResult);
  const { user, column: columnNum } = useAppStore(({ user, column }) => ({
    user,
    column,
  }));

  const isShowRecommendTopic = useMemo(() => {
    return (
      recommendResultTest.value === "string_1" ||
      recommendResultTest.value === "string_2" ||
      recommendResultTest.value === "string_3" ||
      recommendResultTest.value === "string_4"
    );
  }, [recommendResultTest.value]);

  const filterIdMap = useMemo(() => {
    let map = null;
    try {
      if (filterIds) {
        map = filterUrlParams.decode(filterIds);
      }
    } catch (e) {
      console.error("filter_ids对象转换失败");
    }
    return map;
  }, [filterIds]);

  const category = useMemo(() => {
    return Object.values(filterIdMap || {}).reduce((result, value) => {
      if (result) {
        return result;
      } else {
        const match = value.match(/material_category:(.*)/);
        return match && match[1];
      }
    }, "");
  }, [filterIdMap]);

  const queryAction = useMemo(() => {
    // 服务端渲染时，不做初始化的一些操作
    if (initRef.current) {
      pageRef.current = 1;
      setHasMore(true);
      setDataSource([]);
    } else {
      initRef.current = true;
    }

    return async () => {
      if (!q) {
        return;
      }
      if (pageRef.current === 1) {
        setIsRecalSearch(false);
      }
      const filter_ids = filterIdMap
        ? Object.values(filterIdMap).reduce((result, value) => {
            result.push(value);
            return result;
          }, [])
        : null;

      // 设置如果超过30秒，显示服务器繁忙，请稍等片刻...
      const timer = setTimeout(() => {
        setBusy(true);
      }, 10000);

      const result = await getSearchPinsByQingzhou({
        text: q,
        ...(sort ? { sort } : null),
        ...(filter_ids ? { filter_ids } : null),
        material: true,
        limit: 40,
        page: pageRef.current,
        position: "search_material",
      });

      // 如果结果返回有问题直接设置繁忙，如果没问题就清楚定时器
      if (result?.err) {
        setBusy(true);
      } else {
        clearTimeout(timer);
        setBusy(false);
      }

      // 设置搜索结果数量到全局状态
      setSearch({
        search_result_number: result.total || 0,
      });

      // 搜索推荐主题， 仅在第一页请求更新数据
      if (pageRef.current === 1) {
        if (result.relations) {
          setKeywordMap(result.relations);
        }

        if (result.rec_topic_material?.recommendType !== "material") {
          setRecommend(result.rec_topic_material);
        } else {
          setRecommend([]);
        }
      }

      const pins = result?.pins || [];
      /**
       * 展示部分匹配的情况
       * 1.素材数量<=30分词数>1,且用户登陆了
       * 2.素材数量<=30分词数>1,用户没登陆，且素材数量为0
       */
      if (
        result.total <= 30 &&
        result.split_words?.length > 1 &&
        (user || (!user && !pins.length))
      ) {
        setIsRecalSearch(true);
        // setHasMore(false);
        setSplitWords(result.split_words);
      }
      if (pins.length <= 0) {
        setHasMore(false);
      }

      // 搜索结果也第N屏后插入主题, 仅在recommendResultTest实验下需要插入主题
      if (result.topics && isShowRecommendTopic) {
        const recommendTopics = result.topics
          .map((item) => {
            return {
              ...item,
              pin_id: `topic_${item.filter_id}`,
              type: RENDERCARDTYPE.topicCollectionA,
            };
          })
          // 把没有采集的过滤掉，避免展示异常
          .filter((item) => item?.pins?.length > 0);

        if (recommendTopics[0]) {
          // 第一个放到最前面
          pins.unshift(recommendTopics[0]);
        }

        if (recommendTopics[1]) {
          //第二个放到中间位置
          pins.splice(Math.ceil(pins.length / 2), 0, recommendTopics[1]);
        }
      }
      setDataSource((dataSource) => dataSource.concat(pins));
    };
  }, [q, filterIdMap, sort, user, setRecommend, isShowRecommendTopic]);

  const queryRecommend = useMemo(() => {
    return async () => {
      const result = await getAds({
        positions: [
          AD_POSITION.SEARCH_WATERFALL_FIXED_1,
          AD_POSITION.SEARCH_WATERFALL_FIXED_2,
          AD_POSITION.SEARCH_WATERFALL_RANDOM_1,
        ],
        variables: {
          user_tag: ["material"],
          category: [category || "none"],
          search_keyword: [q],
        },
      });

      setAds(
        result?.reduce((result, item) => {
          if (item) {
            result.push({
              ...item,
              pin_id: `recommend-${item.material.id}`,
              type: "recommend",
            });
          } else {
            result.push(null);
          }
          return result;
        }, []) || []
      );
    };
  }, [category, q]);

  const queryQuestionaire = useMemo(() => {
    return async () => {
      const result = await getDeliveryDetail("web-search-material-feedback");
      setQuestionaire(
        result?.pit_modules?.[0]?.material
          ? {
              type: "questionaire",
              pin_id: `questionaire-${result?.pit_modules?.[0]?.module_id}`,
              id: result?.pit_modules?.[0]?.module_id,
              name: result?.pit_modules?.[0]?.module_name,
              search_word: q,
              ...result?.pit_modules?.[0]?.material,
            }
          : null
      );
    };
  }, [q]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);
  useEffect(() => {
    queryRecommend();
  }, [queryRecommend]);
  // useEffect(() => {
  //   queryKeyword();
  // }, [queryKeyword]);
  useEffect(() => {
    queryQuestionaire();
  }, [queryQuestionaire]);

  const onLoadMore = useCallback(() => {
    pageRef.current += 1;
    queryAction();
  }, [queryAction]);

  const onChangeKeyword = (item) => {
    let searchKeyword = q;
    if (item.isReplace) {
      searchKeyword = item.keyword;
    } else {
      const keyword = Object.keys(keywordMap).reduce((result, key) => {
        if (result) {
          return result;
        }
        const item = keywordMap[key].find((item) => q.endsWith(item.keyword));
        return item?.keyword || "";
      }, "");

      if (keyword) {
        searchKeyword = searchKeyword.replace(keyword, item.keyword);
      } else {
        searchKeyword = `${q} ${item.keyword}`;
      }
    }
    setSearch({
      search_type: "筛选器-点击",
    });
    router.push({
      page: "/search",
      query: {
        q: searchKeyword,
        ...(sort ? { sort } : null),
        ...(type ? { type } : null),
        ...(filterIds ? { filter_ids: filterIds } : null),
      },
    });
  };

  useMount(() => {
    stewardInstance.getPositionDelivery({
      "/search": ["material_search_nps"],
    });
  });

  const recommendSearchWordsB = useMemo(() => {
    // 只有当有推荐搜索词数据时才显示
    if (!recommendSearchWords || recommendSearchWords.length === 0) {
      return [];
    }

    // 将推荐搜索词按5个为一组进行分割
    const chunkSize = 5;
    const chunks = [];
    for (let i = 0; i < recommendSearchWords.length; i += chunkSize) {
      chunks.push(recommendSearchWords.slice(i, i + chunkSize));
    }

    // 为每组创建一个组件对象，只渲染满5个搜索词的组合
    return chunks
      .filter((chunk) => chunk.length === 5) // 🎯 只保留正好5个搜索词的组合
      .map((chunk, index) => ({
        pin_id: `recommend-search-words-${q}-group-${index}`,
        type: RENDERCARDTYPE.recommendSearchWordsB,
        mergeCol: Math.min(columnNum, 5),
        isBanner: true,
        recommendSearchWords: chunk,
        currentTabType: "material", // 素材tab类型，用于选择pgc_url
        groupIndex: index, // 添加组索引，用于区分不同组
      }));
  }, [recommendSearchWords, columnNum, q]);

  const list = useMemo(() => {
    if (dataSource.length <= 0 || ads.length <= 0) {
      return dataSource;
    }

    if (randomNumRef.current === null) {
      randomNumRef.current = parseInt(Math.random() * 10) + 11;
    }

    const num = randomNumRef.current;

    const list = [
      ...ads.slice(0, 1).filter((i) => i),
      ...dataSource.slice(0, num),
    ];

    const newList = [
      ...list.slice(0, 1),
      ...ads.slice(1, 2).filter((i) => i),
      ...list.slice(1),
      ...ads.slice(2, 3).filter((i) => i),
      ...dataSource.slice(num),
    ];

    if (newList.length > 60 && questionaire) {
      newList.splice(60, 0, questionaire);
    }

    // 🔧 关键修复：先去重，避免重复数据影响推荐搜索词插入位置
    // 先去重，移除重复的pin_id
    const deduplicatedList = uniqBy(newList, "pin_id");

    // 分组插入推荐搜索词，基于去重后的列表长度来判断插入位置
    if (recommendSearchWordsB.length > 0) {
      // 从后往前插入，避免索引偏移问题
      for (let i = recommendSearchWordsB.length - 1; i >= 0; i--) {
        const targetPosition = 41 + i * 30; // 第一组在第41位，第二组在第71位，第三组在第101位...

        // 基于去重后的列表长度判断是否可以插入
        if (deduplicatedList.length >= targetPosition) {
          // 直接使用目标位置，因为已经基于去重后的列表
          const actualInsertPosition = targetPosition;

          // 确保插入位置不超过当前列表长度
          if (actualInsertPosition <= deduplicatedList.length) {
            deduplicatedList.splice(
              actualInsertPosition,
              0,
              recommendSearchWordsB[i]
            );
          }
        }
      }
    }

    return deduplicatedList;
  }, [dataSource, ads, questionaire, recommendSearchWordsB]);

  return (
    <div className={styles.pin} data-search-word={q}>
      {isFilterPanelVisible ? (
        <FilterToggleButton relationList={keywordMap} />
      ) : (
        <RelationWords relationList={keywordMap} />
      )}
      {isShowRecommendTopic && Object.keys(recommend || {}).length > 0 && (
        <RecommendTopicList
          searchWord={searchWord}
          topics={recommend}
          onClose={onCloseRecommend}
          recommendResultTest={recommendResultTest}
        />
      )}
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <PinList
            dataSource={list}
            hasMore={hasMore}
            isSearch={true}
            searchWord={router.query?.q}
            onLoadMore={onLoadMore}
            loadingContent={
              busy ? (
                <div className={styles.busy}>服务器繁忙，请稍等片刻...</div>
              ) : null
            }
          />
        </Then>
        <Else>{!isRecallSearch && empty}</Else>
      </If>
      <When condition={isRecallSearch && !hasMore}>
        <RecallSearch
          splitWords={splitWords}
          query={query}
          isAllMatch={isAllMatch}
          haveData={!!dataSource.length}
          type={type}
          setIsAllMatch={setIsAllMatch}
          dataSource={dataSource}
          isMaterial={true}
        ></RecallSearch>
      </When>
    </div>
  );
}
